import React from 'react'
import { Heart, Target, Eye, Award } from 'lucide-react'
import Card from '../ui/Card'
import Button from '../ui/Button'

const AboutSection = () => {
  const features = [
    {
      icon: Heart,
      title: "Misión",
      description: "Formar ciudadanos íntegros con competencias académicas, sociales y emocionales que contribuyan al desarrollo de la sociedad."
    },
    {
      icon: Eye,
      title: "Visión", 
      description: "Ser reconocidos como una institución educativa líder en formación integral y excelencia académica en la región Caribe."
    },
    {
      icon: Target,
      title: "Objetivos",
      description: "Promover el desarrollo integral de nuestros estudiantes a través de metodologías innovadoras y valores sólidos."
    },
    {
      icon: Award,
      title: "Calidad",
      description: "Mantener altos estándares educativos con un equipo docente calificado y comprometido con la excelencia."
    }
  ]

  return (
    <section className="section-padding bg-gradient-to-b from-white to-gardenia-gold/5">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gardenia-dark mb-6">
            Conoce Nuestra 
            <span className="text-gradient block mt-2">Institución</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Institución educativa oficial, inclusiva y con enfoque diferencial, que lidera la formación 
            de sujetos emancipadores capaces de transformar sus realidades para promover la convivencia 
            armónica y elevar su calidad de vida.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => {
            const IconComponent = feature.icon
            return (
              <Card key={index} className="text-center hover-lift">
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-gardenia-red/10 to-gardenia-green/10 mb-4">
                    <IconComponent className="h-8 w-8 text-gardenia-red" />
                  </div>
                  <Card.Title>{feature.title}</Card.Title>
                </div>
                <Card.Content>
                  {feature.description}
                </Card.Content>
              </Card>
            )
          })}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-gardenia-dark mb-6">
            ¿Quieres saber más sobre nosotros?
          </h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Descubre nuestra historia completa, metodología educativa y el compromiso 
            que tenemos con la formación integral de nuestros estudiantes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button to="/nosotros" size="lg">
              Conoce Más
            </Button>
            <Button to="/contacto" variant="outline" size="lg">
              Contáctanos
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection